var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoFormula01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "function",
    transform: "translate(536 625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1196",
    d: "M-518-621.6v-2.9c-4.1,0-7.6,2.9-8.3,6.9l-1.7,9.1h-3.9v2.9h3.4l-1.6,8.6c-0.5,2.6-2.8,4.5-5.4,4.5v2.9 c4.1,0,7.6-2.9,8.3-6.9l1.7-9.1h3.2v-2.9h-2.6l1.6-8.6C-523-619.7-520.7-621.6-518-621.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1197",
    d: "M-516.5-615.8l-1.2-0.9c-0.1,0.1-2.5,3.4-2.5,9.6s2.4,9.5,2.5,9.6l2.3-1.8c0,0-1.9-2.7-1.9-7.9 c0-5.2,1.9-7.9,1.9-7.9L-516.5-615.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1198",
    d: "M-505.3-614.9c0,0,1.9,2.7,1.9,7.9s-1.9,7.9-1.9,7.9l1.2,0.9l1.2,0.9c0.1-0.1,2.5-3.4,2.5-9.6 c0-6.3-2.4-9.5-2.5-9.6L-505.3-614.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1199",
    d: "M-509-611.5l-1.7,2.4l-1.7-2.4l-2.4,1.7l2.3,3.2l-2.3,3.2l2.4,1.7l1.7-2.4l1.7,2.4l2.4-1.7l-2.3-3.2 l2.3-3.2L-509-611.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFormula01);
export default __webpack_public_path__ + "static/media/ico-formula-01.2e8ad68fc8fd626d19ee6e42015542a0.svg";
export { ForwardRef as ReactComponent };